import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../AuthProvider/AuthProvider'

const ProtectedBlockchainAdmin = () => {
  const { isLocalAuth } = useAuth()

  switch (isLocalAuth) {
    case false:
      return <Navigate to='/login' replace />
    case true:
      return <Outlet />
    default:
      return <Navigate to='/login' replace />
  }
}

export default ProtectedBlockchainAdmin

